import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Subscription} from "rxjs";
import {ScadenzeStoreService} from "../../Scadenzario/_services/scadenze-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AngularFileUploaderConfig} from "../../shared/file-uploader/angular-file-uploader.types";
import {ApiRestService} from "../../shared/_services/api-rest.service";
import {ApiPathsService} from "../../api-paths.service";
import {AngularFileUploaderComponent} from "../../shared/file-uploader/angular-file-uploader.component";
import {DownloadService} from "../../shared/_services/download.service";

@Component({
  selector: 'app-client-import-modal',
  templateUrl: './import-lavorazioni.component.html'
})
export class ImportLavorazioniComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  @Input() IsModal: boolean = true;
  @Output() Uploaded = new EventEmitter<boolean>();
  url: string = this.apiPaths.getBaseAPI() + "/progetti/lavorazioni/lavorare";
  @ViewChild('fileUpload')
  private fileUpload:  AngularFileUploaderComponent;
  afuConfig: AngularFileUploaderConfig = {
    multiple: false,
    maxSize: 5,
    formatsAllowed: "pdf,doc,docx,xls,xlsx,jpg,png,txt,ods,odt",
    uploadAPI:  {
      url: this.url,
      method: "POST",
      headers: this.apirest.headerforfile(),
      responseType: 'blob',
    },
    paramsType: "body",
    theme: "dragNDrop",
    hideProgressBar: false,
    hideResetBtn: false,
    hideSelectBtn: false,
    hideUploadButton: true,
    fileNameIndex: true,
    replaceTexts: {
      selectFileBtn: 'Seleziona il File',
      resetBtn: 'Reset',
      uploadBtn: 'Carica',
      dragNDropBox: 'Trascina Qui il file',
      attachPinBtn: 'Attach Files...',
      afterUploadMsg_success: 'Successfully Uploaded !',
      afterUploadMsg_error: 'Upload Failed !',
      sizeLimit: 'Size Limit'
    }
  };
  constructor(
    private store: ScadenzeStoreService,
    private modalService: NgbModal,
    private apirest: ApiRestService,
    private apiPaths: ApiPathsService,
    private downloadService: DownloadService,
  ) { }

  ngOnInit(): void {
  }
  saveModalButton() {
    this.fileUpload.uploadFiles();
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
  onResetClick() {
  }
  DocUploaded(data) {
    this.downloadService.downloadFile(data)
    this.Uploaded.emit(true);
    this.closeBtnClick();
  }
}
